import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-devices-cpu1-icon',
  templateUrl: './devices-cpu1.component.html'
})
export class DevicesCPU1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
